// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608032333/js/" + chunkId + "." + {"44":"c2883e42","225":"ed90ac14","481":"02558ca5","486":"0f647968","770":"98c56eb2"}[chunkId] + ".0.4563368753748719.chunk.js";
};